// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"60a192374d46ce2e","946":"32834e04fcf04b4b"}[chunkId] + ".js";
};